module.exports = __webpack_public_path__ + "static/media/Biovina.e1fd0250.svg";